// Product.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import ProductSectionValueAndWhere from "../Components/ProductSectionValueAndWhere";
import LifeWheelSection from "../Components/LifeWheelSection";
import LifeBalancePhone from "../Images/Accueil/macbookfeed.png";
import "../Style/ProductPage.css";
import "../Style/Accueil.ObsidianAura.css";

/**
 * REQUIREMENTS:
 * - Accueil.ObsidianAura.css loaded globally (defines :root --life-* and life-home__overlay, life-container, etc.)
 * - i18n namespace: "product" with keys provided below
 * - If your app DOES NOT provide a global dark canvas, this page injects a fixed dark background.
 */

export default function Product() {
  const { t } = useTranslation("product");

  return (
    <main className="life-home product">
      {/* Ensure dark background exists (home relies on a canvas; product may not) */}
      <div className="product-bg" />
      <div className="life-home__overlay" />

      {/* HERO (simple, optional but recommended) */}
      <section className="life-section product-hero">
        <div className="life-container">
          <div className="product-heroGrid">
            <div>
              <div className="product-eyebrow">{t("hero.eyebrow")}</div>
              <h1 className="product-h1">{t("hero.title")}</h1>
              <p className="product-lead">{t("hero.subtitle")}</p>

              <div className="product-ctaRow">
                <a className="life-ctaPrimary" href={t("hero.cta_primary.href")}>
                  {t("hero.cta_primary.label")}
                </a>
                <a className="product-ctaSecondary" href={t("hero.cta_secondary.href")}>
                  {t("hero.cta_secondary.label")}
                </a>
              </div>

              <p className="life-ctaMeta">{t("hero.reassurance")}</p>

              <div className="product-chips">
                {t("hero.chips", { returnObjects: true })?.map?.((c, idx) => (
                  <span key={idx} className="product-chip">
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <figure className="life-glass hiw-heroMedia" aria-label={t("a11y.preview", "Aperçu du système Life")}>
              <img
                className="hiw-heroImg"
                src={LifeBalancePhone}
                alt="Aperçu du cockpit Life : résumé, insights et trajectoire"
                loading="lazy"
              />
            </figure>
          </div>
        </div>
      </section>

      <div className="life-divider" />

      {/* 2) Domains wheel */}
      <LifeWheelSection />

      <div className="life-divider" />

      {/* 3) Value + Where */}
      <ProductSectionValueAndWhere />
    </main>
  );
}
